import { AuthModel } from "../models/auth.model"

export class AuthService {
    static saveAuth(auth: AuthModel) {
        localStorage.setItem('auth2', JSON.stringify(auth))
    }

    static hasAuth() {
        return localStorage.getItem('auth2') != null
    }

    static clearAuth() {
        localStorage.removeItem('auth2')
    }

    static getAuth() {
        if (localStorage.getItem('auth2') == null) 
            throw new Error('NO_AUTH')

        return JSON.parse(localStorage.getItem('auth2')!)
    }

}